<script setup>
import axios from "axios";
import { ref } from "vue";

import store from "@/store/store";
import router from "@/router";

const loading = ref(false);
const username = ref();
const password = ref();
let access = ref(store.getters['tokens/access']);
let refresh = ref(store.getters['tokens/refresh']);
let remember_account = ref(false);
// Create a reactive variable for error message
const loginError = ref(null);
const capsLockOn = ref(false);

const pass = ref(true)
const checkCapsLock = (event) => {
  if (event instanceof KeyboardEvent) {
    capsLockOn.value = event.getModifierState && event.getModifierState("CapsLock");
  }
};

const login = async () => {
  loading.value = true;
  const response = await axios.post("login/", {
    username: username.value,
    password: password.value,
  }, { timeout: 5000 }).then(pass.value = true).catch((response)=>{
    console.log(response);
    switch (response.status) {
      case 400:
      case 401:
        loginError.value = 'Неверный логин или пароль';
        break;
      case 403:
        loginError.value = 'Аккаунт не действителен';
        break;
      case 404:
        loginError.value = 'Сервер не отвечает';
        break;
      case 429:
        loginError.value = 'Слишком много запросов. Попробуйте позже';
        break;
      case 500:
        loginError.value = 'Ошибка на сервере. Пожалуйста, попробуйте позже';
        break;
      case 503:
        loginError.value = 'Сервис временно недоступен';
        break;
      default:
        loginError.value = 'Ошибка: нет интернета';
      }
      pass.value = false;
  });
  if (!pass.value) {
    loading.value=false;
    return
  }
  access = response.data.access;
  refresh = response.data.refresh;
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + access;

  const account = await axios.get('account/');
  const form = {
    remember_account: remember_account.value,
    username : account.data.user.username,
    is_superuser : account.data.user.is_superuser,
    first_name : account.data.user.first_name,
    last_name : account.data.user.last_name,
    email : account.data.user.email,
    phone_number : account.data.phone_number,
    is_stuff : account.data.user.is_stuff,
    is_manager : account.data.is_manager,
    is_fitter : account.data.is_fitter,
    is_engineer : account.data.is_engineer,
    abonent : account.data.abonent,
    date_joined : account.data.user.date_joined
  };
  loading.value = false;
  await store.dispatch('profile/setAccount', form);
  await store.dispatch('tokens/setAccess', access);

  remember_account.value ?
      await store.dispatch('tokens/setRefresh', refresh) :
      await store.dispatch('tokens/setRefresh', null)

  await router.push('/');

};
</script>

<template>
  <div class="container vh-100 d-flex justify-content-center align-items-center">
    <div class="row justify-content-center align-items-center">
      <div class="col-10 col-md-6">
        <div class="card shadow py-5 border border-1 border-dark-subtle">
          <div class="card-body text-center">
            <h1 class="h3 mb-3 fw-normal">Вход</h1>
            <!-- Add @submit.prevent to prevent default form submission -->
            <form @submit.prevent="login">
              <div class="row gy-2 overflow-hidden">
                <div class="col-12">
                  <div class="form-floating mb-3">
                    <input v-model="username" type="text" class="form-control" name="username" id="username_validation" placeholder="Имя пользователя" required>
                    <label for="username_validation" class="form-label">Имя пользователя</label>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-floating mb-3">
                    <input
                        v-model="password"
                        type="password"
                        class="form-control"
                        name="password"
                        id="password_validation"
                        placeholder="Пароль"
                        required
                        @keydown="checkCapsLock"
                        @keyup="checkCapsLock"
                    />
                    <label for="password_validation" class="form-label">Пароль</label>
                    <div v-if="capsLockOn" class="text-warning h6 mt-2">
                      Внимание: Caps Lock включен!
                    </div>
                    <div v-if="loginError" class="text-danger h5 d-block">
                      {{ loginError }}
                    </div>
                    <div v-if="loading" class="spinner-border" role="status">
                      <span class="visually-hidden">Загрузка...</span>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="col d-flex justify-content-evenly">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="remember" v-model="remember_account">
                      <label for="remember">Запомнить</label>
                    </div>
                  </div>
                  <div class="col">
                    <button type="submit" class="btn btn-primary">Войти</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
